import Select from 'react-select';
import classNames from 'classnames';
import { Label } from 'reactstrap';

export const customTextField = ({
    label,
    input,
    meta: { touched, error },
    disabled,
    type = 'search',
    rows,
}) => (
    <>
        <div
            className={classNames('bg-white rounded shadow-sm', {
                bored: touched && error,
            })}>
            <input
                {...input}
                placeholder={label}
                type={type}
                disabled={disabled}
                rows={rows || 1}
                className={classNames('p-2 form-control-input bg bg-white')}
            />
        </div>
        {label && (
            <Label className="float-left text-white text-12 mt-2 mr-2">
                {label}
            </Label>
        )}
        <span
            className={classNames('float-left mt-1', {
                'text-danger bg-white px-2 rounded': touched && error,
            })}>
            {(touched && error && <>{error}</>) || <>&nbsp;</>}
        </span>
    </>
);

export const customTextArea = ({
    id,
    label,
    input,
    meta: { touched, error },
    disabled,
    type,
    rows,
    placeholder,
    onKeyUp = null,
    onKeyDown = null,
}) => (
    <>
        <div className="bg-white rounded border border-secondary shadow-sm">
            <textarea
                {...input}
                id={id}
                placeholder={label || placeholder}
                type={type}
                disabled={disabled}
                rows={rows || 1}
                className="p-2 form-control-input bg bg-white"
                onKeyUp={onKeyUp}
                onKeyDown={onKeyDown}
            />
        </div>
        {label && (
            <Label className="text-light float-left text-12 mt-2 mr-2">
                {label}
            </Label>
        )}
        <span
            className={classNames('float-left mt-1', {
                'text-danger bg-white px-2 rounded': touched && error,
            })}>
            {(touched && error && <>{error}</>) || <>&nbsp;</>}
        </span>
    </>
);

export const customSelectField = ({
    label,
    input,
    meta: { touched, error },
    disabled,
    children,
}) => (
    <>
        <div className="d-flex justify-content-between">
            <select
                style={{ flexGrow: '1' }}
                className={classNames('w-75 p-2 rounded bg-white', {
                    bored: touched && error,
                })}
                {...input}
                disabled={disabled}>
                {label && (
                    <option value="" disabled defaultValue>
                        {label}
                    </option>
                )}
                {children}
            </select>
        </div>
        {label && (
            <Label className="text-light float-left text-12 mt-2 mr-2">
                {label}
            </Label>
        )}
        <span
            className={classNames('float-left mt-1', {
                'text-danger bg-white px-2 rounded': touched && error,
            })}>
            {(touched && error && <>{error}</>) || <>&nbsp;</>}
        </span>
    </>
);

export const reactSelectField = ({
    label,
    input,
    meta: { touched, error },
    disabled,
    children,
}) => (
    <>
        <Select
            sm={12}
            {...input}
            onChange={(value) => input.onChange(value)}
            onBlur={() => input.onBlur(input.value)}
            options={children}
            placeholder={label}></Select>
        {label && <Label className="text-white text-12">{label}</Label>}
        <span
            className={classNames('float-left mt-1', {
                'text-danger bg-white px-2 rounded': touched && error,
            })}>
            {(touched && error && <>{error}</>) || <>&nbsp;</>}
        </span>
    </>
);

export const required = (value) => (value ? undefined : 'Field Required');
export const email = (value) =>
    !value ||
    value.length === 0 ||
    (value?.length > 0 && /[A-Za-z0-9]+@[A-Za-z]+\.[A-Za-z]+/.test(value))
        ? undefined
        : 'Email is incorrectly formatted, try again';
export const isGuidEmpty = (value) =>
    !value || value === '00000000-0000-0000-0000-000000000000';
